export var AuthUserGroups = {
    Admin: "admin",
    Warehouse: "warehouse",
    Customer: "customer"
};
